import React from 'react';
import Logo from '../Logo';
import AccountMenu from '../AccountMenu/AccountMenu';
import { User } from '../../types/auth';
import './MobileHeader.css';

interface MobileHeaderProps {
  user: User | null;
  onLogout: () => void;
  onOpenSuggestion: () => void;
}

/**
 * The narrow-screen top bar (Faz 23, T-180): the logo and name, the account avatar with its
 * menu. The tabs are in the bottom bar; the old progress strip and side menu are gone.
 */
const MobileHeader: React.FC<MobileHeaderProps> = ({ user, onLogout, onOpenSuggestion }) => (
  <div className="mobile-header-container">
    <header className="mobile-header">
      <div className="mobile-header-content">
        <a href="#/home" className="mobile-brand">
          <Logo size={26} className="mobile-logo" />
          <span className="mobile-title">Riselio</span>
        </a>
        <AccountMenu user={user} onLogout={onLogout} onOpenSuggestion={onOpenSuggestion} />
      </div>
    </header>
  </div>
);

export default MobileHeader;
